import type { CompteursDepotsCv } from '@rh/shared';
import { appel } from './api';

/**
 * Compteurs de la page « CV à rattacher », partagés entre la page et le lien
 * de navigation : la page les relit pendant l'analyse, le lien affiche aussitôt
 * le nombre de CV « à confirmer » sans interroger l'API de son côté. Nombres
 * seulement, jamais de contenu.
 */
let derniers: CompteursDepotsCv | null = null;
const ecouteurs = new Set<(compteurs: CompteursDepotsCv) => void>();

export function derniersCompteursCv(): CompteursDepotsCv | null {
  return derniers;
}

export function publierCompteursCv(compteurs: CompteursDepotsCv): void {
  derniers = compteurs;
  for (const ecouteur of [...ecouteurs]) ecouteur(compteurs);
}

export function ecouterCompteursCv(ecouteur: (compteurs: CompteursDepotsCv) => void): () => void {
  ecouteurs.add(ecouteur);
  return () => {
    ecouteurs.delete(ecouteur);
  };
}

/** Lit les compteurs et les publie. */
export async function lireCompteursCv(): Promise<CompteursDepotsCv> {
  const compteurs = await appel<CompteursDepotsCv>('/cv-a-rattacher/compteurs');
  publierCompteursCv(compteurs);
  return compteurs;
}
